/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Raifragen } from '../../models/raifragen';

export interface ApiRaifragenPost$Plain$Params {
      body?: Raifragen
}

export function apiRaifragenPost$Plain(http: HttpClient, rootUrl: string, params?: ApiRaifragenPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Raifragen>> {
  const rb = new RequestBuilder(rootUrl, apiRaifragenPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Raifragen>;
    })
  );
}

apiRaifragenPost$Plain.PATH = '/api/Raifragen';
